module.exports = __webpack_public_path__ + "img/yushengmacang.b539736f.png";